export const RoleFeatureCode = {
  DASHBOARD_REQUESTS: "F0000",
  DASHBOARD_CALLS: "F0001",
  REPORTS: "F0002",
  ITEMS_AVAILABLE: "F0003",
  SECTORS_AND_ROOMS: "F0004",
  USERS: "F0005",
  ROLES_AND_PERMISSIONS: "F0006",
  GROUPS: "F0007",
  CALLS: "F0008",
  REQUESTS: "F0009",
  OTHER_REQUESTS: "F0010",
  MONITOR_EVENTS: "F0011",
  CREATE_ORDER: "F0012",
  CENTRALS: "F0013",
  VIEWER_USERS: "F0014",
  APPLICATION_LOGS: "F0015",
  HARDWARE_CONFIG: "F0015",
  HARDWARE_ROOMS: "F0016",
  HARDWARE_SETTINGS: "F0017",
  REPORTS_ORDERS: "F0018",
};

export const FeatureCodeAction = {
  VIEW: "view",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  ACCEPT: "accept",
  ON_THE_WAY: "on_the_way",
};

export const SCREENS = [
  {
    code: RoleFeatureCode.ITEMS_AVAILABLE,
    name: "management.positionAndPermissions.modal.text.itensAvailable",
  },
  {
    code: RoleFeatureCode.SECTORS_AND_ROOMS,
    name: "management.positionAndPermissions.modal.text.sectoresAndRooms",
  },
  {
    code: RoleFeatureCode.USERS,
    name: "management.positionAndPermissions.modal.text.users",
  },
  {
    code: RoleFeatureCode.ROLES_AND_PERMISSIONS,
    name: "management.positionAndPermissions.modal.text.rolesAndPermissions",
  },
  {
    code: RoleFeatureCode.GROUPS,
    name: "management.positionAndPermissions.modal.text.groups",
  },
  {
    code: RoleFeatureCode.DASHBOARD_REQUESTS,
    name: "management.positionAndPermissions.modal.text.dashboardRequests",
    onlyView: true,
  },
  {
    code: RoleFeatureCode.DASHBOARD_CALLS,
    name: "management.positionAndPermissions.modal.text.dashboardCalls",
    onlyView: true,
  },
  {
    code: RoleFeatureCode.REPORTS,
    name: "management.positionAndPermissions.modal.text.reports",
    onlyView: true,
  },  
  {
    code: RoleFeatureCode.HARDWARE_CONFIG,
    name: "management.positionAndPermissions.modal.text.hardwareConfig",
  },
  {
    code: RoleFeatureCode.HARDWARE_ROOMS,
    name: "management.positionAndPermissions.modal.text.hardwareRooms",
  },
  {
    code: RoleFeatureCode.HARDWARE_SETTINGS,
    name: "management.positionAndPermissions.modal.text.hardwareSettings",
  },
];
